
const SvgComponent = (props) => (
  <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M1.531 13.46c-.782.11-1.513-.438-1.529-1.227a12 12 0 115.037 9.541c-.644-.458-.682-1.37-.15-1.954.53-.585 1.43-.617 2.09-.183a9.139 9.139 0 10-4.118-7.8c-.014.79-.547 1.514-1.33 1.623z"
        fill="#363636"
      />
    </svg>
);

export default SvgComponent;

// import React from 'react';

// const LoaderIcon = (props) => (
//   <svg
//     width={24}
//     height={24}
//     viewBox="0 0 24 24"
//     fill="none"
//     {...props}
//   >
//     <path
//       d="M1.531 13.46c-.782.11-1.513-.438-1.529-1.227a12 12 0 115.037 9.541c-.644-.458-.682-1.37-.15-1.954.53-.585 1.43-.617 2.09-.183a9.139 9.139 0 10-4.118-7.8c-.014.79-.547 1.514-1.33 1.623z"
//       fill="#363636"
//     />
//   </svg>
// );

// export default LoaderIcon;
